
<div class="comparison-card">
  <app-text class="is-family-semiBold text-18 has-spacing-bottom-xl">{{'🏠 ' + ('common-app.__COMPARISON_WITH_SIMILAR_HOMES' | AsyncLang | async)}}</app-text>
    @if (viewModel$ | async; as vm) {
      @if (vm.report.home_size && vm.report.heating_time_compared_to_similar_houses_in_percentage)
      {
        @if (vm.report.heating_time_compared_to_similar_houses_in_percentage) {
          @if (vm.report.heating_time_compared_to_similar_houses_in_percentage >= 90)
          {
          <app-text class="text-16 text-grey-70 subtext"
                    [text]="'common-app.__COMPARISON_SIMILAR_HOMES_WORST' | AsyncLang:[getPercentageRound(vm.report.heating_time_compared_to_similar_houses_in_percentage)] | async"></app-text>
          }
          @else if (vm.report.heating_time_compared_to_similar_houses_in_percentage > 50)
          {
          <app-text class="text-16 text-grey-70 subtext"
                    [text]="'common-app.__COMPARISON_SIMILAR_HOMES_LEAST_EFFICIENT' | AsyncLang:[getPercentageRound(vm.report.heating_time_compared_to_similar_houses_in_percentage)] | async"></app-text>
          }
          @else if (vm.report.heating_time_compared_to_similar_houses_in_percentage > 10)
          {
          <app-text class="text-16 text-grey-70 subtext"
                    [text]="'common-app.__COMPARISON_SIMILAR_HOMES_MOST_EFFICIENT' | AsyncLang:[getPercentageRound(vm.report.heating_time_compared_to_similar_houses_in_percentage)] | async"></app-text>
          }
          @else
          {
          <app-text class="text-16 text-grey-70 subtext"
                    [text]="'common-app.__COMPARISON_SIMILAR_HOMES_BEST' | AsyncLang:[getPercentageRound(vm.report.heating_time_compared_to_similar_houses_in_percentage)] | async"></app-text>
          }
        }
      }
        <div
        class="chart-container"
        [class.d-none]="!vm.report.heating_time_compared_to_similar_houses_in_percentage || !vm.report.home_size"
        >
          <app-icon name="home-group" class="text-24 text-subcolor home-icon"></app-icon>
          <div class="is-flex is-justify-end canva-chart">
            <canvas #MyChart></canvas>
            <app-icon name="heating" class="text-24 text-subcolor heating-icon"></app-icon>
          </div>
          <div class="is-flex is-align-center container-labels">
            <div class="label is-flex is-align-self-start">
              <div class="green-circle"></div>
              <app-text class="text-12 text-subcolor" [text]="'common-app.__CONSUMPTION_COMPARISON_LEGEND_THE_MOST_ECONOMICAL' | AsyncLang | async"/>
            </div>
            <div class="label is-flex is-align-self-start">
              <div class="orange-circle"></div>
              <app-text class="text-12 text-subcolor" [text]="'common-app.__CONSUMPTION_COMPARISON_LEGEND_THE_AVERAGE' | AsyncLang | async"/>
            </div>
            <div class="label is-flex is-align-self-start">
              <div class="red-circle"></div>
              <app-text class="text-12 text-subcolor" [text]="'common-app.__CONSUMPTION_COMPARISON_LEGEND_THE_GREEDIEST' | AsyncLang | async"/>
            </div>
          </div>
        </div>
      @if (!vm.report.home_size) {
        <div class="container-blur-img">
          <div class="info_setup_home_cat">
            <div class="is-flex text-24">
              <app-icon name="information" class="text-orange-alert"/>
              <app-text class="text-info text-14 is-cursor-pointer" [text]="'common-app.__CONSUMPTION_SAVINGS_COMPARISON_ENTER_INFORMATION' | AsyncLang | async" (click)="handleShowModalSettings()"></app-text>
            </div>
          </div>
        </div>
        <ng-container>
          <app-modal
            [display]="showModalSettings()"
          >
            <app-settings-frame
              (close)="handleCloseModalSettings()"
              class="iframe"
              [showClose]="true"
              [frameUrl]="settingsLegrandUrl$ | async"></app-settings-frame>
          </app-modal>

        </ng-container>
      }
    }
 </div>


